import React from "react";
import { motion } from "framer-motion";
import { MdEmail, MdPhone } from "react-icons/md";
import "./Contact.scss";

function Contact() {
  return (
    <div className="contact">
      <div id="contact" className="contact_section">
        <motion.h1
          whileInView={{ y: [-20, 0], opacity: [0, 1] }}
          transition={{ duration: 0.7 }}
          className="contact_title"
        >
          Get in Touch
        </motion.h1>
        <div className="contact_content">
          <div className="contact_details">
            <a href="tel:234-810-090-5850" className="details">
              <MdPhone className="icon" /> Call Me
            </a>
            <a href="mailto:emekankwo49@gmail.com" className="details">
              <MdEmail className="icon" /> Send a Message
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
